import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom-v5-compat';

import { QuestionMarkOutlinedSvg } from 'components/svgs/QuestionMarkOutlinedSvg/QuestionMarkOutlinedSvg';
import { OpDropdown } from 'new-components/DLS/OpDropdown/OpDropdown';
import { OpButton } from 'new-components/DLS/OpButton/OpButton';
import { releaseNotesRoute } from 'routes/constants';
import { useAppContext } from 'new-components/OpAppScaffold/components/AppContext';
import { getAccessToken } from 'utils/accessToken';
import { useOpQuery } from 'utils/customHooks/useOpQuery';
import { checkAuthIsUPCPartnerOrg } from 'utils/checkAuthIsUPCPartnerOrg';
import { getOpParams } from 'utils/getOpParams';

import { FeedbackMenuItem } from './components/FeedbackMenuItem/FeedbackMenuItem';

import './HelpMenu.scss';

export const HelpMenu = () => {
  const { t } = useTranslation();
  const { orgId } = getOpParams();
  const navigate = useNavigate();
  const { app } = useAppContext();

  const token = getAccessToken();
  const { data: tokenData } = useOpQuery({
    apiEndpointName: 'describeAccessToken',
    parameters: [token],
    select: (res) => res.json.data,
  });

  const isAltaPartnerApp = app === 'partnerCenter';
  const isPartnerIdentity = tokenData?.tokenScopeList?.some(
    (item) => item.org?.isUnified && checkAuthIsUPCPartnerOrg(item),
  );

  const items = [
    {
      isVisible: isAltaPartnerApp,
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://docs.avigilon.com/bundle/alta-partner-app/page/alta-partner/before-you-start.htm"
        >
          {t('Getting started guide')}
        </a>
      ),
    },
    {
      isVisible: isPartnerIdentity && isAltaPartnerApp,
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://vsapartners.motorolasolutions.com/s/"
        >
          {t('Avigilon Partner Portal')}
        </a>
      ),
    },
    {
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://docs.avigilon.com/category/alta-access-control"
        >
          {t('FAQs')}
        </a>
      ),
    },
    {
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://docs.avigilon.com/category/alta-access-control"
        >
          {t('Installation guides')}
        </a>
      ),
    },
    {
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.openpath.com/request-security-docs"
        >
          {t('Security docs')}
        </a>
      ),
    },
    {
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://openpath.readme.io"
        >
          {t('Developer support')}
        </a>
      ),
    },
    {
      label: (
        <a
          target="_blank"
          rel="noopener noreferrer"
          href="https://control.openpath.com/license-attribution.html"
        >
          {t('Licensing information')}
        </a>
      ),
    },
    {
      label: <FeedbackMenuItem />,
    },
    {
      label: t('Release notes'),
      isVisible: app !== 'partnerCenter',
      onClick: () => {
        // release notes route should be releaseNotes in all apps
        navigate(`o/${orgId}/${releaseNotesRoute}`);
      },
    },
  ].map(({ isVisible = true, ...item }, i) => {
    if (!isVisible) {
      return null;
    }

    return {
      ...item,
      key: i.toString(),
    };
  });

  return (
    <OpDropdown
      className="help-menu"
      trigger={['click']}
      menu={{ items }}
      placement="bottomRight"
      arrow={{ pointAtCenter: true }}
      overlayClassName="help-menu-overlay"
    >
      <OpButton
        className="help-menu__button"
        icon={<QuestionMarkOutlinedSvg width={18} height={18} />}
        type="link"
      />
    </OpDropdown>
  );
};
